/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/PublicationData/utils/validatePublicationForm.ts.
 */

import type { FormField } from "../../../../../../interfaces/formInterfaces";
import {
  type ContributorFormErrors,
  fieldLabel,
  getFirstFormError,
  hasFieldValue,
} from "../../shared/contributorFormValidation";
import { isPublicationFieldDisabled } from "./publicationFieldConditionality";

export { getFirstFormError };

/** Exported function — validate Publication Form. */
export function validatePublicationForm(
  fields: FormField[],
  values: Record<string, string>,
  files: Record<string, File | null>
): ContributorFormErrors {
  const errors: ContributorFormErrors = {};
  const typeOfPublication = String(values.typeOfPublication ?? "");
  const hasDataPublished = String(values.hasDataPublished ?? "");

  for (const field of fields) {
    if (!field.isEnabled || !field.isMandatory) continue;

    const fieldName = field.name;
    const disabled = isPublicationFieldDisabled({
      fieldName,
      typeOfPublication,
      hasDataPublished,
    });
    if (disabled) continue;

    if (field.type === "FILE") {
      const file = files[fieldName];
      const existing = values[fieldName];
      if (!file && !String(existing ?? "").trim()) {
        errors[fieldName] = `${fieldLabel(field)} is required.`;
      }
      continue;
    }

    if (!hasFieldValue(values[fieldName])) {
      errors[fieldName] = `${fieldLabel(field)} is required.`;
    }
  }

  return errors;
}
